const pathAPI = `/${process.env.REACT_APP_SERVICE_PATH_OSP}/api/common`;

export const apiCommon = {
  getPlace: `${pathAPI}/place`,
  getNews: `${pathAPI}/news`,
  getNewDetail: `${pathAPI}/newsDetail`,
  getOptionSearch: `${process.env.REACT_APP_SERVICE_PATH_OSP}/api/msisdn/app/groupMsisdn/get`,
};
